import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IntubationService } from '../../intubation/services/intubation.service'
import * as actions from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setLaryngoscopeBladeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const intubationService = new IntubationService(serviceId)
  try {
    const response: IOptionsResponse = yield call([intubationService, intubationService.getLaryngoscopeBladeOptions])
    const { entity } = response
    yield put(actions.setLaryngoscopeBladeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setLaryngoscopeBladeOptions() error: ${e}`))
  }
}
export function* setLaryngoscopeBladeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setLaryngoscopeBladeOptions)
}
